
/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  BlockExpenseApprovalRequest,
  ExpenseBatchApprovedRequest,
  ExpenseBatchResource,
  ExpenseBatchSummaryResource,
  ExpenseCreateBatchRequest,
  ExpenseListForApprovalResource,
  ExpenseListResource,
  ExpenseResource,
  ExpensesSentToPunchoutResource,
  SendExpensesToPunchoutRequest,
} from '../models';
import {
    BlockExpenseApprovalRequestFromJSON,
    BlockExpenseApprovalRequestToJSON,
    ExpenseBatchApprovedRequestFromJSON,
    ExpenseBatchApprovedRequestToJSON,
    ExpenseBatchResourceFromJSON,
    ExpenseBatchResourceToJSON,
    ExpenseBatchSummaryResourceFromJSON,
    ExpenseBatchSummaryResourceToJSON,
    ExpenseCreateBatchRequestFromJSON,
    ExpenseCreateBatchRequestToJSON,
    ExpenseListForApprovalResourceFromJSON,
    ExpenseListForApprovalResourceToJSON,
    ExpenseListResourceFromJSON,
    ExpenseListResourceToJSON,
    ExpenseResourceFromJSON,
    ExpenseResourceToJSON,
    ExpensesSentToPunchoutResourceFromJSON,
    ExpensesSentToPunchoutResourceToJSON,
    SendExpensesToPunchoutRequestFromJSON,
    SendExpensesToPunchoutRequestToJSON,
} from '../models';

export interface ApproveABatchOfExpensesRequest {
    projectId: string;
    expenseBatchId: string;
    expenseBatchApprovedRequest: ExpenseBatchApprovedRequest;
}

export interface BlockExpenseApprovalOperationRequest {
    projectId: string;
    expenseId: string;
    blockExpenseApprovalRequest: BlockExpenseApprovalRequest;
}

export interface CreateBatchForSeveralExpensesRequest {
    projectId: string;
    expenseCreateBatchRequest: ExpenseCreateBatchRequest;
}

export interface DeleteExpenseBatchRequest {
    projectId: string;
    expenseBatchId: string;
}

export interface GetExpenseDetailRequest {
    projectId: string;
    expenseId: string;
}

export interface GetExpensesRequest {
    projectId: string;
}

export interface GetExpensesForApprovalRequest {
    projectId: string;
}

export interface ListAllExpensesInBatchRequest {
    projectId: string;
    expenseBatchId: string;
}

export interface SendExpensesToPunchoutOperationRequest {
    projectId: string;
    expenseBatchId: string;
    sendExpensesToPunchoutRequest: SendExpensesToPunchoutRequest;
}

export interface UnblockExpenseApprovalRequest {
    projectId: string;
    expenseId: string;
}

/**
 * 
 */
export class ExpenseApi extends runtime.BaseAPI {

    /**
     * Validate a batch of expense submitted by the freelancer
          */
    async approveABatchOfExpensesRaw(requestParameters: ApproveABatchOfExpensesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling approveABatchOfExpenses().'
            );
        }

        if (requestParameters['expenseBatchId'] == null) {
            throw new runtime.RequiredError(
                'expenseBatchId',
                'Required parameter "expenseBatchId" was null or undefined when calling approveABatchOfExpenses().'
            );
        }

        if (requestParameters['expenseBatchApprovedRequest'] == null) {
            throw new runtime.RequiredError(
                'expenseBatchApprovedRequest',
                'Required parameter "expenseBatchApprovedRequest" was null or undefined when calling approveABatchOfExpenses().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/project-client/api/project/{projectId}/expense/batch/{expenseBatchId}/approve`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))).replace(`{${"expenseBatchId"}}`, encodeURIComponent(String(requestParameters['expenseBatchId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ExpenseBatchApprovedRequestToJSON(requestParameters['expenseBatchApprovedRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Validate a batch of expense submitted by the freelancer
          */
    async approveABatchOfExpenses(requestParameters: ApproveABatchOfExpensesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.approveABatchOfExpensesRaw(requestParameters, initOverrides);
    }

    /**
     * Update the expense that cannot be approved
          */
    async blockExpenseApprovalRaw(requestParameters: BlockExpenseApprovalOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling blockExpenseApproval().'
            );
        }

        if (requestParameters['expenseId'] == null) {
            throw new runtime.RequiredError(
                'expenseId',
                'Required parameter "expenseId" was null or undefined when calling blockExpenseApproval().'
            );
        }

        if (requestParameters['blockExpenseApprovalRequest'] == null) {
            throw new runtime.RequiredError(
                'blockExpenseApprovalRequest',
                'Required parameter "blockExpenseApprovalRequest" was null or undefined when calling blockExpenseApproval().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/project-client/api/project/{projectId}/expense/{expenseId}/block-approval`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))).replace(`{${"expenseId"}}`, encodeURIComponent(String(requestParameters['expenseId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BlockExpenseApprovalRequestToJSON(requestParameters['blockExpenseApprovalRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Update the expense that cannot be approved
          */
    async blockExpenseApproval(requestParameters: BlockExpenseApprovalOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.blockExpenseApprovalRaw(requestParameters, initOverrides);
    }

    /**
     * Create a batch of quotes before validate it to be able to download a quote
          */
    async createBatchForSeveralExpensesRaw(requestParameters: CreateBatchForSeveralExpensesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ExpenseBatchResource>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling createBatchForSeveralExpenses().'
            );
        }

        if (requestParameters['expenseCreateBatchRequest'] == null) {
            throw new runtime.RequiredError(
                'expenseCreateBatchRequest',
                'Required parameter "expenseCreateBatchRequest" was null or undefined when calling createBatchForSeveralExpenses().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<ExpenseBatchResource>({
            path: `/project-client/api/project/{projectId}/expense/batch`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ExpenseCreateBatchRequestToJSON(requestParameters['expenseCreateBatchRequest']),
        }, initOverrides);

        if (response._data) { response._data=ExpenseBatchResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Create a batch of quotes before validate it to be able to download a quote
          */
    async createBatchForSeveralExpenses(requestParameters: CreateBatchForSeveralExpensesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ExpenseBatchResource> {
        const response = await this.createBatchForSeveralExpensesRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Delete the batch of expense and the underling quote
          */
    async deleteExpenseBatchRaw(requestParameters: DeleteExpenseBatchRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling deleteExpenseBatch().'
            );
        }

        if (requestParameters['expenseBatchId'] == null) {
            throw new runtime.RequiredError(
                'expenseBatchId',
                'Required parameter "expenseBatchId" was null or undefined when calling deleteExpenseBatch().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/project-client/api/project/{projectId}/expense/batch/{expenseBatchId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))).replace(`{${"expenseBatchId"}}`, encodeURIComponent(String(requestParameters['expenseBatchId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Delete the batch of expense and the underling quote
          */
    async deleteExpenseBatch(requestParameters: DeleteExpenseBatchRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteExpenseBatchRaw(requestParameters, initOverrides);
    }

    /**
     * Expenses detail
          */
    async getExpenseDetailRaw(requestParameters: GetExpenseDetailRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ExpenseResource>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling getExpenseDetail().'
            );
        }

        if (requestParameters['expenseId'] == null) {
            throw new runtime.RequiredError(
                'expenseId',
                'Required parameter "expenseId" was null or undefined when calling getExpenseDetail().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ExpenseResource>({
            path: `/project-client/api/project/{projectId}/expense/{expenseId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))).replace(`{${"expenseId"}}`, encodeURIComponent(String(requestParameters['expenseId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ExpenseResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Expenses detail
          */
    async getExpenseDetail(requestParameters: GetExpenseDetailRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ExpenseResource> {
        const response = await this.getExpenseDetailRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * List the expenses
          */
    async getExpensesRaw(requestParameters: GetExpensesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ExpenseListResource>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling getExpenses().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ExpenseListResource>({
            path: `/project-client/api/project{projectId}/expense`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ExpenseListResourceFromJSON(response._data); }
        return response;
    }

    /**
     * List the expenses
          */
    async getExpenses(requestParameters: GetExpensesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ExpenseListResource> {
        const response = await this.getExpensesRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * List the expenses submitted by the freelancer for approval
          */
    async getExpensesForApprovalRaw(requestParameters: GetExpensesForApprovalRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ExpenseListForApprovalResource>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling getExpensesForApproval().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ExpenseListForApprovalResource>({
            path: `/project-client/api/project/{projectId}/expense/for-approval`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ExpenseListForApprovalResourceFromJSON(response._data); }
        return response;
    }

    /**
     * List the expenses submitted by the freelancer for approval
          */
    async getExpensesForApproval(requestParameters: GetExpensesForApprovalRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ExpenseListForApprovalResource> {
        const response = await this.getExpensesForApprovalRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * List all the expenses in this batch used to create a quote before approval
          */
    async listAllExpensesInBatchRaw(requestParameters: ListAllExpensesInBatchRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ExpenseBatchSummaryResource>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling listAllExpensesInBatch().'
            );
        }

        if (requestParameters['expenseBatchId'] == null) {
            throw new runtime.RequiredError(
                'expenseBatchId',
                'Required parameter "expenseBatchId" was null or undefined when calling listAllExpensesInBatch().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ExpenseBatchSummaryResource>({
            path: `/project-client/api/project/{projectId}/expense/batch/{expenseBatchId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))).replace(`{${"expenseBatchId"}}`, encodeURIComponent(String(requestParameters['expenseBatchId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ExpenseBatchSummaryResourceFromJSON(response._data); }
        return response;
    }

    /**
     * List all the expenses in this batch used to create a quote before approval
          */
    async listAllExpensesInBatch(requestParameters: ListAllExpensesInBatchRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ExpenseBatchSummaryResource> {
        const response = await this.listAllExpensesInBatchRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Send a batch of submitted expenses to ERP (via Punchout)
          */
    async sendExpensesToPunchoutRaw(requestParameters: SendExpensesToPunchoutOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ExpensesSentToPunchoutResource>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling sendExpensesToPunchout().'
            );
        }

        if (requestParameters['expenseBatchId'] == null) {
            throw new runtime.RequiredError(
                'expenseBatchId',
                'Required parameter "expenseBatchId" was null or undefined when calling sendExpensesToPunchout().'
            );
        }

        if (requestParameters['sendExpensesToPunchoutRequest'] == null) {
            throw new runtime.RequiredError(
                'sendExpensesToPunchoutRequest',
                'Required parameter "sendExpensesToPunchoutRequest" was null or undefined when calling sendExpensesToPunchout().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<ExpensesSentToPunchoutResource>({
            path: `/project-client/api/project/{projectId}/expense/batch/{expenseBatchId}/sendToErp`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))).replace(`{${"expenseBatchId"}}`, encodeURIComponent(String(requestParameters['expenseBatchId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SendExpensesToPunchoutRequestToJSON(requestParameters['sendExpensesToPunchoutRequest']),
        }, initOverrides);

        if (response._data) { response._data=ExpensesSentToPunchoutResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Send a batch of submitted expenses to ERP (via Punchout)
          */
    async sendExpensesToPunchout(requestParameters: SendExpensesToPunchoutOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ExpensesSentToPunchoutResource> {
        const response = await this.sendExpensesToPunchoutRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Update the expense that it can be approved
          */
    async unblockExpenseApprovalRaw(requestParameters: UnblockExpenseApprovalRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling unblockExpenseApproval().'
            );
        }

        if (requestParameters['expenseId'] == null) {
            throw new runtime.RequiredError(
                'expenseId',
                'Required parameter "expenseId" was null or undefined when calling unblockExpenseApproval().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/project-client/api/project/{projectId}/expense/{expenseId}/unblock-approval`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))).replace(`{${"expenseId"}}`, encodeURIComponent(String(requestParameters['expenseId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Update the expense that it can be approved
          */
    async unblockExpenseApproval(requestParameters: UnblockExpenseApprovalRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.unblockExpenseApprovalRaw(requestParameters, initOverrides);
    }

}
